import { render, staticRenderFns } from "./AllReceivablesFilter.vue?vue&type=template&id=2c8dbcc6&"
import script from "./AllReceivablesFilter.vue?vue&type=script&lang=js&"
export * from "./AllReceivablesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports